import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { config } from 'src/app/config/api.config';
import { applicationMentorat } from 'src/app/model/ApplicationMentors';
import { CertificatesMentorat } from 'src/app/model/certificates-mentorat.model';
import { CustomResponse } from 'src/app/model/dto/CustomResponse';
import { CandidatMentor } from '../components/list-mentors/list-mentors.component';
import { CertificateCandidature } from 'src/app/model/CertificateCandidature.interface';
import { PagedResponse } from '../components/groupe/moodle.models';

@Injectable({
  providedIn: 'root',
})
export class MentoratService {
  constructor(private httpClient: HttpClient) { }

  private buildPaginationParams(
    page: number = 0,
    size: number = 10,
  ): HttpParams {
    return new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
  }

  public getAllCertificateMentors(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/mentoratCertificate/list`,
    );
  }

  getAllCertificateMentoratPaginated(
    page: number = 0,
    size: number = 10,
  ): Observable<CustomResponse> {
    const params = this.buildPaginationParams(page, size);
    return this.httpClient.get<CustomResponse>(
      `${config.apiBaseUrl}/mentoratCertificate/list/paged`,
      { params },
    );
  }

  getAllApplicationsMentoratPaginated(
    page: number = 0,
    size: number = 10,
  ): Observable<CustomResponse> {
    const params = this.buildPaginationParams(page, size);
    return this.httpClient.get<CustomResponse>(
      `${config.apiBaseUrl}/applicationMentorat/list/paged`,
      { params },
    );
  }

  public createApplicationMentors(application: any): Observable<any> {
    return this.httpClient.post<any>(
      `${config.apiBaseUrl}/applicationMentorat/createApplicationMentorat`,
      application,
    );
  }

  createMentoratCertificate(
    mentoratCertificateDTO: CertificatesMentorat,
  ): Observable<HttpResponse<any>> {
    return this.httpClient.post<any>(
      `${config.apiBaseUrl}/mentoratCertificate/createCertificatMentorat`,
      mentoratCertificateDTO,
      { observe: 'response' },
    );
  }

  public getCurrentApplicationMentorat(cohorte: string) {
    return this.httpClient.get<any>(
      `${config.openBaseUrl}/opencontroller/currentApplicationMentorat/${cohorte}`,
    );
  }

  public getAllCandidatsMentors() {
    return this.httpClient.get<any>(
      `${config.openBaseUrl}/opencontroller/candidatures-mentorats`,
    );
  }

  getCandidatMentoratDocuments(candidatId: number): Observable<any> {
    return this.httpClient.get(
      `${config.apiBaseUrl}/candidatures-mentorats/${candidatId}/documents`,
    );
  }

  updateCandidatureCertificatStatus(
    candidatId: number,
    certificatId: number,
    status: string,
  ): Observable<any> {
    return this.httpClient.put(
      `${config.apiBaseUrl}/candidature-mentorats/${candidatId}/certificats/${certificatId}/status`,
      null,
      { params: { status } },
    );
  }

  notifierDeliberationCandidatureMentorat(iuf: string): Observable<string> {
    return this.httpClient.post(
      `${config.apiBaseUrl}/candidature-mentorats/send-recap-email/${iuf}`,
      null,
      { responseType: 'text' },
    );
  }

  public addCandidatureMentorat(data: FormData): Observable<CustomResponse> {
    return this.httpClient.post<any>(
      `${config.openBaseUrl}/opencontroller/addCandidatureMentorat`,
      data,
    );
  }

  public mentoratConfirm(iuf: String): Observable<CustomResponse> {
    return this.httpClient.get<CustomResponse>(
      `${config.openBaseUrl}/opencontroller/mentorat/confirmation/${iuf}`,
    );
  }
  public createGroupe(grp: any): Observable<any> {
    return this.httpClient.post<any>(`${config.apiBaseUrl}/groups`, grp);
  }

  getAllCertificate(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/newParcourCertificate/simple/all`,
    );
  }
  getAllGroupe(): Observable<any> {
    return this.httpClient.get<any>(`${config.apiBaseUrl}/groups`);
  }
  getAllGroupewithdetail(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/groups/all_groups_with_details`,
    );
  }
  searchBeneficiarybyEmail(email: string, groupId: string): Observable<any> {
    const params = new HttpParams().set('q', email).set('groupId', groupId);
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/beneficiary/search-on-certificate`,
      {
        params,
      },
    );
  }
  // searchBeneficiarybyEmail(email: string): Observable<any> {
  //   return this.httpClient.get<any>(
  //     `${config.apiBaseUrl}/beneficiary/beneficiary2/${email}`
  //   );
  // }

  public updateBeneficiaryGroupe(
    id: any,
    beneficiariesList: string[],
  ): Observable<any> {
    return this.httpClient.put<any>(
      `${config.apiBaseUrl}/groups/${id}/beneficiaries`,
      { beneficiaries: beneficiariesList },
    );
  }
  beneficiaryByGroup(id: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/groups/${id}/beneficiaries-list`,
    );
  }
  beneficiaryByGroupstat(id: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/groups/${id}/details-with-stats`,
    );
  }

  public createSsGroupe(grp: any): Observable<any> {
    return this.httpClient.post<any>(`${config.apiBaseUrl}/sub-groups`, grp);
  }
  getAllssGroupe(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/sub-groups/all/with-infos`,
    );
  }
  beneficiaryBySsGroup(id: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/sub-groups/${id}/beneficiaries`,
    );
  }
  public updateBeneficiarySsGroupe(
    id: any,
    beneficiariesList: string[],
  ): Observable<any> {
    return this.httpClient.put<any>(
      `${config.apiBaseUrl}/sub-groups/${id}/beneficiaries`,
      { beneficiaries: beneficiariesList },
    );
  }

  deleteBeneficiaryGroup(
    id: any,
    beneficiariesList: string[],
  ): Observable<any> {
    let params = new HttpParams();
    beneficiariesList.forEach((benefId) => {
      params = params.append('beneficiaries', benefId);
    });
    return this.httpClient.delete<any>(
      `${config.apiBaseUrl}/groups/${id}/beneficiaries`,
      { params: params },
    );
  }

  sousGroupByGroup(id: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/sub-groups/by-group/${id}`,
    );
  }
  public updateBeneficiaryGroupeLot(id: any, size: number): Observable<any> {
    return this.httpClient.put<any>(
      `${config.apiBaseUrl}/groups/${id}/beneficiaries-by-batch`,
      { batchSize: size },
    );
  }

  deleteBeneficiarySsGroup(
    id: any,
    beneficiariesList: string[],
  ): Observable<any> {
    let params = new HttpParams();
    beneficiariesList.forEach((benefId) => {
      params = params.append('beneficiaries', benefId);
    });
    return this.httpClient.delete<any>(
      `${config.apiBaseUrl}/sub-groups/${id}/beneficiaries`,
      { params: params },
    );
  }

  getCohortewithCertificate(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/newParcourCertificate/all-cohortes-with-certificates`,
    );
  }

  groupByMentorIUF(iuf: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/groups/mentor/${iuf}`,
    );
  }
  subgroupByMentorIUF(iuf: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/sub-groups/mentor/${iuf}`,
    );
  }

  getCertificatesByStatus(
    iuf: string,
    status?: string,
  ): Observable<CertificateCandidature[]> {
    let params = new HttpParams();
    if (status) {
      params = params.set('status', status);
    }
    return this.httpClient.get<CertificateCandidature[]>(
      `${config.apiBaseUrl}/candidature-mentorats/candidatures/${iuf}/certificates`,
      { params },
    );
  }

  // Méthodes helpers spécifiques pour chaque statut
  getCertificatesEnCours(iuf: string): Observable<CertificateCandidature[]> {
    return this.getCertificatesByStatus(iuf, 'En cours de traitement');
  }

  getCertificatesRejetes(iuf: string): Observable<CertificateCandidature[]> {
    return this.getCertificatesByStatus(iuf, 'Rejete');
  }

  getCertificatesRetenues(iuf: string): Observable<CertificateCandidature[]> {
    return this.getCertificatesByStatus(iuf, 'Retenu');
  }

  getApprenantDocuments(iuf: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/alfrescoMentorat/mentoratFolder/${iuf}`,
    );
  }

  uploadFileToAlfrescoMentorat(
    fichier: FormData,
    iuf: string,
  ): Observable<any> {
    return this.httpClient.post<any>(
      `${config.apiBaseUrl}/alfrescoMentorat/uploadFileMentorat?iuf=${iuf}`,
      fichier,
    );
  }

  public exportPdfMentorPayments(yearMonth: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/alfresco/renditions/content/mentor-payments/${yearMonth}`,
    );
  }

  public exportExcelMentorPayments(month: any): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/mentor-payments/export-excel/${month}`,
    );
  }

  importMentorPayments(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.httpClient.post<any>(
      `${config.apiBaseUrl}/mentor-payments/import-excel`,
      formData,
    );
  }

  deleteDocument(nodeId: string): Observable<any> {
    return this.httpClient.delete<any>(
      `${config.apiBaseUrl}/alfrescoMentorat/deleteOnAlfresco/${nodeId}`,
    );
  }

  getlistCoursMentorat(groupId: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/courses/getCourse/${groupId}`,
    );
  }
  public getCohorteMentor(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/applicationMentorat/cohortes`,
    );
  }
  public getCertificatbycohortMentor($cohorte: any): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/mentoratCertificate/by-cohorte/${$cohorte}`,
    );
  }

  public getMentorRetenubyCertificatCohort(
    certificatId: any,
    cohort: any,
  ): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/candidature-mentorats/${certificatId}/retenus`,
      { params: { cohorte: cohort } },
    );
  }
  createEmploiTemps(emploi: any): Observable<any> {
    return this.httpClient.post<any>(`${config.apiBaseUrl}/courses`, emploi);
  }
  updateEmploidutemps(id: any, course: any): Observable<any> {
    return this.httpClient.put<any>(
      `${config.apiBaseUrl}/courses/${id}`,
      course,
    );
  }

  deleteEmploidutemps(id: any): Observable<any> {
    return this.httpClient.delete<any>(`${config.apiBaseUrl}/courses/${id}`);
  }
  getBeneficiaryinCohort(iuf: any): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/beneficiary/isInCohorte/${iuf}`,
    );
  }
  getGroupbyBeneficiary(iuf: any): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/groups/beneficiary/${iuf}`,
    );
  }
  getSsGroupbyBeneficiary(iuf: any): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/sub-groups/beneficiary/${iuf}`,
    );
  }
  geturlsalle(
    courseId: any,
    fullName: string,
    isFCC: boolean,
    iuf?: any,
  ): Observable<any> {
    const params = {
      fullName,
      isFCC,
      ...(iuf && { iuf }),
    };
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/courses/getSall/Url/${courseId}/join`,
      {
        params: params,
        responseType: 'text' as 'json',
      },
    );
  }
  getReplay(courseId: any): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/courses/${courseId}/recording`,
      { responseType: 'text' as 'json' },
    );
  }
  getCahiertexte(meetingId: any): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/courses/getBigBlueButtonAnalics/${meetingId}`,
    );
  }
  getCoursebymentor(mentorEmail: any): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/courses/courses/mentor/${mentorEmail}`,
    );
  }

  public getResponsableCertificat(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/beneficiary/responsables-certificats`,
    );
  }
  public addResponsableGroupe(iuf: string, idGroup: string): Observable<any> {
    return this.httpClient.post<any>(
      `${config.apiBaseUrl}/groups/addResponsibleToGroup/${iuf}/${idGroup}`,
      {},
    );
  }
  getGroupsByResponsable(responsableIuf: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/responsable/${responsableIuf}/groups`,
    );
  }
  getCandidatsByResponsable(responsableIuf: string) {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/responsable/${responsableIuf}/mentors`,
    );
  }
  getCertificatesByResponsable(responsableIuf: string) {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/responsable/${responsableIuf}/certificates`,
    );
  }

  getDistinctCourses(): Observable<{ id: string; title: string }[]> {
    return this.httpClient.get<{ id: string; title: string }[]>(
      `${config.apiBaseUrl}/course-analytics/list-courses`,
    );
  }

  getCourseAnalyticWithFilters(params: any): Observable<PagedResponse<any>> {
    let httpParams = new HttpParams()
      .set('page', params.page.toString())
      .set('size', params.size.toString())
      .set('sortBy', params.sortBy)
      .set('sortDir', params.sortDir);

    if (params.searchTerm) {
      httpParams = httpParams.set('searchTerm', params.searchTerm);
    }
    if (params.courseId) {
      httpParams = httpParams.set('courseId', params.courseId);
    }
    if (params.status !== undefined && params.status !== 'all') {
      httpParams = httpParams.set('paid', params.status);
    }

    if (params.month) {
      httpParams = httpParams.set('month', params.month);
    }
    if (params.mentorIuf) {
      httpParams = httpParams.set('mentorIuf', params.mentorIuf);
    }
    if (params.year) {
      httpParams = httpParams.set('year', params.year);
    }
    if (params.responsableIuf) {
      httpParams = httpParams.set('responsableIuf', params.responsableIuf);
    }

    return this.httpClient.get<PagedResponse<any>>(
      `${config.apiBaseUrl}/course-analytics/courses-by`,
      { params: httpParams },
    );
  }
  getPaymentStatusLabel(status: boolean): string {
    switch (status) {
      case true:
        return 'PAYÉ';
      //  case 'IN_PROGRESS':
      // return 'EN COURS';
      case false:
        return 'NON PAYÉ';
      default:
        return 'INCONNU';
    }
  }
  getPaymentStatusClass(status: boolean): string {
    switch (status) {
      case true:
        return '#28b45b';
      // case 'IN_PROGRESS':
      //   return '#007bff';
      case false:
        return '#f04438';
      default:
        return '';
    }
  }

  getMentorsWithCourses(): Observable<
    { iuf: string; firstname: string; lastname: string }[]
  > {
    return this.httpClient.get<
      { iuf: string; firstname: string; lastname: string }[]
    >(`${config.apiBaseUrl}/course-analytics/mentors`);
  }

  getCourseAnalyticByMentor(
    params: any,
    iuf: string,
  ): Observable<PagedResponse<any>> {
    let httpParams = new HttpParams()
      .set('page', params.page.toString())
      .set('size', params.size.toString());
    return this.httpClient.get<PagedResponse<any>>(
      `${config.apiBaseUrl}/course-analytics/mentor/${iuf}`,
      { params: httpParams },
    );
  }

  public updateSinglePayement(idpayement: string): Observable<any> {
    return this.httpClient.patch<any>(
      `${config.apiBaseUrl}/mentor-payments/${idpayement}/toggle-status`,
      {},
    );
  }

  getApplicationMentoratById(id: number): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/applicationMentorat/${id}`,
    );
  }

  updateApplicationMentorat(id: number, payload: any): Observable<any> {
    return this.httpClient.put<any>(
      `${config.apiBaseUrl}/applicationMentorat/${id}`,
      payload,
    );
  }

  toggleApplicationMentorat(id: number): Observable<any> {
    return this.httpClient.patch<any>(
      `${config.apiBaseUrl}/applicationMentorat/${id}/toggle`,
      {},
    );
  }

  deleteGroupCascade(groupId: number): Observable<void> {
    return this.httpClient.delete<void>(`${config.apiBaseUrl}/groups/${groupId}/cascade`);
  }

  changeMentor(groupId: string, mentorEmail: string): Observable<any> {
    return this.httpClient.put<any>(`${config.apiBaseUrl}/groups/${groupId}/mentor`, { mentorEmail });
  }


  removeMentor(groupId: string): Observable<any> {
    return this.httpClient.delete<any>(`${config.apiBaseUrl}/groups/${groupId}/mentor`);
  }

  public getGroupeById(id: string): Observable<any> {
    return this.httpClient.get<any>(`${config.apiBaseUrl}/groups/${id}`);
  }

  public updateGroupe(id: string, grp: any): Observable<any> {
    return this.httpClient.put<any>(`${config.apiBaseUrl}/groups/${id}`, grp);
  }
  getApprenantCourse(iuf: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/courses/beneficiary/${iuf}/upcoming`,
    );
  }
  getMentorCourse(iuf: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/courses/mentor/${iuf}/schedule`,
    );
  }

  getMentorCourseHours(
    iuf: string,
    month: number,
    year: number,
  ): Observable<any> {
    const params = new HttpParams()
      .set('month', month.toString())
      .set('year', year.toString());

    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/courses/mentor/${iuf}/monthly-hours`,
      { params },
    );
  }

  getAllMentorCourseHours(month: number, year: number): Observable<any> {
    const params = new HttpParams()
      .set('month', month.toString())
      .set('year', year.toString());

    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/courses/mentors/monthly-hours`,
      { params },
    );
  }

}
